import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useOrpc } from '@/_shared/hooks/useOrpc';

/**
 * Every query a repo-link write changes: the links (every `list` entry, workspace-wide and per account),
 * the accounts' repo-link counts, and the docs a link compiles or deletes.
 */
export function useInvalidateLinkedRepos(): () => void {
  const orpc = useOrpc();
  const queryClient = useQueryClient();
  return useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: orpc.warehouseProjects.key() });
    void queryClient.invalidateQueries({ queryKey: orpc.settings.warehouses.listAccounts.queryOptions().queryKey });
    void queryClient.invalidateQueries({ queryKey: orpc.docs.key() });
    void queryClient.invalidateQueries({ queryKey: orpc.contextHub.key() });
  }, [orpc, queryClient]);
}
